import { useQuery } from '@tanstack/react-query';
import { packNameApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function usePackNames() {
  return useQuery({
    queryKey: queryKeys.packNames.list(),
    queryFn: () => packNameApi.listPackNames(),
  });
}
